import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M5 13v3l2 2h4l2-2v-3zM15.168 3.436A7.213 7.213 0 0 0 9 0a7.212 7.212 0 0 0-6.17 3.44 4.136 4.136 0 0 0-.302 3.716L4.286 11.5H7V6a2 2 0 0 1 4 0v5.5h2.714l1.757-4.347a4.132 4.132 0 0 0-.303-3.717z" />
    <path d="M9 5.5a.5.5 0 0 0-.5.5v5.5h1V6a.5.5 0 0 0-.5-.5z" />
  </svg>
);

export default SvgComponent;
